export default __webpack_public_path__ + "static/media/aprilaire-blue-color-logo.4fc87b96.png";